/* global Config */

// Vendor Libs
import {get, cloneDeep, set} from 'lodash';

const formInitialState = {
    fieldErrors: {},
    formErrors: null,
    location: null,
    operators: {},
    customPath: null,
    submitted: false,
    values: {},
};

const genres = Config.base.matureContent ? 'Adult' : '!Adult';

const formsInitialStates = {
    bestMatches: {
        ...cloneDeep(formInitialState),
        operators: {
            titleLanguages: '=in=',
        },
        values: {
            genres,
            titleLanguages: ['en', 'es'],
            '#franchiseOnlyImages': 'true',
        },
    },
    createUser: set(cloneDeep(formInitialState), 'values', {active: true}),
    editUser: set(cloneDeep(formInitialState), 'values', {active: true}),
    mediaItems: {
        ...cloneDeep(formInitialState),
        values: {
            activeOnly: 'true',
        },
        visibleFields: [
            'title||showName',
            'exactSearch',
            'externalNetwork.name||externalNetwork.network.name',
            'service.serviceName',
            'state',
            'idFromPartner',
            'guid||externalGuid',
            'activeOnly',
        ],
        constantFields: ['amsFranchise.const.echostarContentType', 'service.const.serviceName'],
    },
    mediaItemsEnhanced: {
        ...cloneDeep(formInitialState),
        operators: {
            service: {
                serviceName: '=in=',
            },
        },
        values: {
            activeOnly: 'true',
            service: {
                serviceName: ['dany', 'est'],
            },
            state: 'production',
        },
        visibleFields: [
            'title||showName',
            'exactSearch',
            'externalNetwork.name||externalNetwork.network.name',
            'service.serviceName',
            'state',
            'amsFranchise.echostarId||amsEpisode.echostarId',
            'idFromPartner',
            'guid||externalGuid',
            'activeOnly',
        ],
        constantFields: [],
    },
    moviesAndPrograms: {
        ...cloneDeep(formInitialState),
        operators: {
            descriptionLanguage: '=in=',
            titleLanguages: '=in=',
        },
        values: {
            descriptionLanguage: ['en', 'es'],
            genres,
            titleLanguages: ['en', 'es'],
        },
    },
    moviesAndProgramsMappingFranchise: {
        ...cloneDeep(formInitialState),
        operators: {
            descriptionLanguage: '=in=',
            titleLanguages: '=in=',
        },
        values: {
            descriptionLanguage: ['en', 'es'],
            genres,
            titleLanguages: ['en', 'es'],
        },
    },
    moviesAndProgramsMappingEpisodes: set(cloneDeep(formInitialState), 'values', {genres}),
    mediaItemReenrich: set(cloneDeep(formInitialState), 'values', {targetValue: 'ENRICHMENT'}),
    mediaItemsReenrich: set(cloneDeep(formInitialState), 'values', {targetValue: 'ENRICHMENT'}),
    unmappedMediaItems: {
        ...cloneDeep(formInitialState),
        visibleFields: [
            'title||showName',
            'exactSearch',
            'externalNetwork.name||externalNetwork.network.name',
            'service.serviceName',
            'state',
            'idFromPartner',
            'guid||externalGuid',
        ],
        constantFields: [],
    },
    mediaItemsMapped: {
        ...cloneDeep(formInitialState),
        visibleFields: [
            'title||showName',
            'exactSearch',
            'externalNetwork.name||externalNetwork.network.name',
            'service.serviceName',
            'state',
            'idFromPartner',
            'guid||externalGuid',
        ],
        constantFields: [],
    },
};

export default function getFormInitialState(formName) {
    return cloneDeep(get(formsInitialStates, formName, formInitialState));
}
